import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Editor } from 'primereact/editor';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MessageTemplate, MessageTemplateService } from '../services/MessageTemplateService';
import { FloatLabel } from 'primereact/floatlabel';

const EditMessageTemplate: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [templates, setTemplates] = useState<MessageTemplate[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<MessageTemplate | null>(null);
    const [content, setContent] = useState<string>('');
    const [subject, setSubject] = useState<string>('');
    const [loading, setLoading] = useState(true);
    const toast = useRef<Toast>(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            setLoading(true);
            const data = await MessageTemplateService.fetchMessageTemplates();
            setTemplates(data);
            const template = data.find(t => t.id === id);
            if (template) {
                setSelectedTemplate(template);
                setContent(template.content);
                setSubject(template.subject);
            }
            setLoading(false);
        };
        fetchTemplates();
    }, [id]);

    const refreshTemplates = async () => {
        setLoading(true);
        const data = await MessageTemplateService.fetchMessageTemplates();
        setTemplates(data);
        setLoading(false);
    };

    const handleSave = async () => {
        if (selectedTemplate) {
            const updatedTemplate = { ...selectedTemplate, content, subject };
            await MessageTemplateService.editMessageTemplate(selectedTemplate.id, updatedTemplate);
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Template saved successfully!', life: 3000 });
            setSelectedTemplate(null);
            refreshTemplates();
        }
    };

    return (
        <div className="p-grid p-justify-center">
            <Toast ref={toast} />
            {loading ? (
                <div className="flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 200px)' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="p-col-12 p-md-10">
                    <h2>Edit Message Template</h2>
                    <DataTable value={templates} selectionMode="single" onSelectionChange={(e) => {
                        const template = e.value as MessageTemplate;
                        setSelectedTemplate(template);
                        setContent(template.content);
                        setSubject(template.subject);
                    }}>
                        <Column field="name" header="Name" />
                        <Column field="type" header="Type" />
                    </DataTable>
                    {selectedTemplate && (
                        <div>
                            <h3>{selectedTemplate.name}</h3>
                            <div className="p-field">
                                <FloatLabel>
                                    <InputText id="subject" value={subject || ""} onChange={(e) => setSubject(e.target.value)} />
                                    <label htmlFor="subject">Subject</label>
                                </FloatLabel>
                            </div>
                            <Editor value={content} onTextChange={(e) => setContent(e.htmlValue || '')} />
                            <Button label="Save" onClick={handleSave} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default EditMessageTemplate;
